  $.fn.markdown.defaults.iconlibrary = 'fa';